import React from 'react';

const Text = (props) => {
  let textType;

  switch (props.type) {
    case 'tiny':
      textType = (
        <span onClick={props.onClick} className={`tiny ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'tiny-bold':
      textType = (
        <span onClick={props.onClick} className={`tiny bold ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'tiny-semi-bold':
      textType = (
        <span onClick={props.onClick} className={`tiny semi-bold ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'small':
      textType = (
        <span onClick={props.onClick} className={`small ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'small-bold':
      textType = (
        <span onClick={props.onClick} className={`small bold ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'small-semi-bold':
      textType = (
        <span onClick={props.onClick} className={`small semi-bold ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'normal-bold':
      textType = (
        <span onClick={props.onClick} className={`normal bold ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'normal-semi-bold':
      textType = (
        <span onClick={props.onClick} className={`normal semi-bold ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'sub-head':
      textType = (
        <span onClick={props.onClick} className={`sub-head ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'sub-head-bold':
      textType = (
        <span onClick={props.onClick} className={`sub-head bold ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'sub-head-semi-bold':
      textType = (
        <span onClick={props.onClick} className={`sub-head semi-bold ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'heading':
      textType = (
        <span onClick={props.onClick} className={`heading ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'heading-bold':
      textType = (
        <span onClick={props.onClick} className={`heading bold ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'heading-semi-bold':
      textType = (
        <span onClick={props.onClick} className={`heading semi-bold ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
    case 'explanation':
      textType = (
        <p className={`normal explanation ${props.modifiers || ''}`}>{props.children}</p>
      );
      break;
    default:
      textType = (
        <span onClick={props.onClick} className={`normal ${props.modifiers || ''}`}>{props.children}</span>
      );
      break;
  }

  return textType;
};

export default Text;


// WEBPACK FOOTER //
// ./src/ui/Text.js